import { normalizeBoolean } from '@change-corgi/config/fcm/normalizers';

import { createFcmConfig } from '../shared/factory';

export const FCM_PSF_CONTEXTUAL_BANDITS_ENABLED = createFcmConfig('psf_contextual_bandits_enabled', {
	normalizer: normalizeBoolean,
	defaultValue: false,
});
